exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".not-active {\r\n    pointer-events: none;\r\n    cursor: default;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/pakornduangtrakan/Snocko/other/backend-auto/src/app/layout/admin/breadcrumbs/breadcrumbs.component.css
// module id = ../../../../../src/app/layout/admin/breadcrumbs/breadcrumbs.component.css
// module chunks = main